
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
	name: 'Countdown',
})
export default class Countdown extends Vue {
	@Prop({ required: true }) datetime!: Date;

	countdownEnded = false;
	countdownInterval: NodeJS.Timeout | null = null;
	remainingTime = 0;

	get days() {
		return Math.floor(this.remainingTime / (24 * 60 * 60));
	}

	get hours() {
		return Math.floor((this.remainingTime % (24 * 60 * 60)) / (60 * 60));
	}

	get minutes() {
		return Math.floor((this.remainingTime % (60 * 60)) / 60);
	}

	get seconds() {
		return this.remainingTime % 60;
	}

	startCountdown() {
		const currentTime = new Date().getTime();
		const targetTime = new Date(this.datetime).getTime();
		this.remainingTime = Math.max(Math.floor((targetTime - currentTime) / 1000), 0);

		if (this.remainingTime <= 0) {
			this.countdownEnded = true;
			return;
		}

		this.countdownInterval = setInterval(() => {
			if (this.remainingTime > 0) {
				this.remainingTime--;
			} else {
				clearInterval(this.countdownInterval as NodeJS.Timeout);
				this.countdownEnded = true;
			}
		}, 1000);
	}

	mounted() {
		this.startCountdown();
	}

	beforeDestroy() {
		if (this.countdownInterval) {
			clearInterval(this.countdownInterval);
		}
	}
}
